export const ALL_SHORT_LINK_LIST = "list";
export const GET_SHORT_LINK_CREATE = "create";
export const GET_SHORT_LINK_ADD = "add";
export const GET_SHORT_LINK_DETAIL = "detail";
export const GET_SHORT_LINK_UPDATE = "update";
export const GET_SHORT_LINK_VIEW_DETAILS = "visit_detail";
